import React from "react";

import {Configuration} from "./generated/configuration";
import {ApiExtractorCtrlApi} from "./generated/api";

import axios from 'axios';
import {serverUrl} from "./Serveur";

const config = new Configuration();
const axiosInstance = axios.create({});

const api = new ApiExtractorCtrlApi(config, serverUrl, axiosInstance);

export default class ExtractCtrl extends React.Component {

    static async bdnbAllPost(filtre, limit, offset, callback) {
        api.apiBdnbAllPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        })
    }

    static async getDpes(filtre, limit, offset, callback) {
        api.apiDpePost(filtre, limit, offset).then((result) => {
            callback(result.data);
        })
    }

    static async getEtab(filtre, limit, offset, callback) {
        api.apiEtabPost(filtre, limit, offset).then((result) => {
            callback(result.data);
        })
    }


}
